import { styled } from '@mui/material'

export const HighlightedTextWrapper = styled('span')(() => ({
  display: 'inline',
  padding: '4px 8px',
  // Increased line-height creates spacing between wrapped lines
  // Each wrapped line gets its own background box (via box-decoration-break: clone)
  // and the line-height creates the gap between them
  lineHeight: '1.8',
  backgroundColor: '#FFFFFF',
  color: '#000000',
  // This makes each wrapped line have its own background box with padding
  boxDecorationBreak: 'clone',
  WebkitBoxDecorationBreak: 'clone',
  // Allow natural wrapping
  whiteSpace: 'normal',
  wordWrap: 'break-word',
}))
